import { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const OutlineCheckCircleIcon: FC<SVGComponentProps> = ({
  width = 16,
  height = 16,
  stroke = '#15803D',
  fill = 'white'
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2466_16479)">
        <path
          d="M5.0026 7.99992L7.0026 9.99992L11.0026 5.99992M14.6693 7.99992C14.6693 11.6818 11.6845 14.6666 8.0026 14.6666C4.32071 14.6666 1.33594 11.6818 1.33594 7.99992C1.33594 4.31802 4.32071 1.33325 8.0026 1.33325C11.6845 1.33325 14.6693 4.31802 14.6693 7.99992Z"
          stroke={stroke}
          strokeWidth={1.4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2466_16479">
          <rect width={width} height={height} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { OutlineCheckCircleIcon };
